import React from 'react';
import { Badge } from '@chakra-ui/react';

import { STATUS_COLOR } from '../../../modules/school/student-leave/constants';

const MAX_VISIBLE_COUNT = 99;

const isPositiveCount = (value) => typeof value === 'number' && value > 0;

/**
 * Jumlah badge anak-anak grup, ditampilkan di tombol grup selama tertutup.
 *
 * @param {Array<{ badge?: number }>} [children]
 * @returns {number}
 */
export function sumChildBadges(children = []) {
  return children.reduce(
    (total, child) => total + (isPositiveCount(child.badge) ? child.badge : 0),
    0,
  );
}

/**
 * Angka izin menunggu di menu. Tidak dirender bila 0/undefined; di atas 99
 * ditulis "99+". Tanpa animasi (arah desain Task 5).
 *
 * @param {{ count?: number }} props
 */
export function MenuBadge({ count }) {
  if (!isPositiveCount(count)) return null;

  const label = count > MAX_VISIBLE_COUNT ? `${MAX_VISIBLE_COUNT}+` : count;

  return (
    <Badge
      ml="auto"
      px={2}
      fontSize="xs"
      borderRadius="full"
      colorScheme={STATUS_COLOR.pending}
      aria-label={`${count} izin menunggu`}
    >
      {label}
    </Badge>
  );
}
